import { render, staticRenderFns } from "./materials.vue?vue&type=template&id=a4af028e&scoped=true&"
import script from "./materials.vue?vue&type=script&lang=js&"
export * from "./materials.vue?vue&type=script&lang=js&"
import style0 from "./materials.vue?vue&type=style&index=0&id=a4af028e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4af028e",
  null
  
)

export default component.exports